import { format } from "date-fns";

export function formatDate(value: string, dateFormat?: string): string {
  try {
    return format(new Date(`${value}`), dateFormat || "P");
  } catch {
    return "";
  }
}
